import { render, staticRenderFns } from "./MiraLanding.vue?vue&type=template&id=3baa597f&scoped=true&"
import script from "./MiraLanding.vue?vue&type=script&lang=ts&"
export * from "./MiraLanding.vue?vue&type=script&lang=ts&"
import style0 from "./MiraLanding.vue?vue&type=style&index=0&id=3baa597f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa597f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
